import React, { Component } from "react";
import ReactTooltip from "react-tooltip";

class ChatButton extends Component {
  componentDidMount() {
    this.showTooltip();
  }

  showTooltip = () => {
    let tooltip = document.querySelectorAll(`[data-tip]`)[0];
    setTimeout(() => {
      if(sessionStorage.getItem('tipShowed') === null){
        ReactTooltip.show(tooltip);
        sessionStorage.setItem('tipShowed', 1);
      }
    }, 1000);
  };

  openChat = () => {
    this.props.onOpenChat();

    let tooltip = document.querySelectorAll(`[data-tip]`)[0];
    if(tooltip){
      ReactTooltip.hide(tooltip);
      tooltip.removeAttribute('data-tip');
    }
  };

  render() {
    return (
      <button
        title=""
        className="chatToggle"
        onClick={this.openChat}
        data-tip="Bonjour, je suis Mia votre assistante virtuelle"
        data-event='XXX'
      >
        <ReactTooltip
          place="left"
          type="light"
          effect="solid"
          delayShow={0}
          scrollHide={false}
          possibleCustomEventsOff="openChat"
          delayHide={2500}
          // afterShow={() => ReactTooltip.hide()}
        />
      </button>
    );
  }
}

export default ChatButton;
